import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';
import { FAQ } from './FAQs';
import { FontFamily } from './FontFamilies';

const CONTENT_WIDTH = 248;
const KEY_PREFIX = 'faq-answer-paragraph';

type Props = {
  item: FAQ;
};

export const FAQListItem: FunctionComponent<Props> = (props) => {
  const { item } = props;
  return (
    <View style={styles.container}>
      <Text style={styles.question}>{item.question}</Text>
      {item.answerParagraphs.map((answerParagraph, index) =>
        answerParagraph.type === 'text' ? (
          <Text key={`${KEY_PREFIX}-${index}`} style={styles.answer}>
            {answerParagraph.content}
          </Text>
        ) : (
          <BulletItems key={`${KEY_PREFIX}-${index}`} content={answerParagraph.content} />
        )
      )}
    </View>
  );
};

type BulletItemsProps = {
  content: string[];
};

const BulletItems: FunctionComponent<BulletItemsProps> = (props) => (
  <>
    {props.content.map((item, index) => (
      <Text key={`bullet-item-${index}`} style={[styles.answer, styles.bullet]}>
        • {item}
      </Text>
    ))}
  </>
);

const styles = StyleSheet.create({
  container: {
    width: CONTENT_WIDTH,
  },
  question: {
    fontFamily: FontFamily.TimesRoman,
    fontSize: 14,
    lineHeight: 1.3,
  },
  answer: {
    fontFamly: FontFamily.Helvetica,
    fontSize: 10.5,
    lineHeight: 1.4,
    marginTop: 5,
  },
  bullet: {
    marginLeft: 5,
  },
});
